import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { SEO } from '../../utils/seo';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="プライバシーポリシー | 株式会社G11"
        description="株式会社G11のプライバシーポリシー。個人情報の取り扱いについて詳しくご説明します。"
        keywords="プライバシーポリシー,個人情報保護,情報セキュリティ"
      />
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-teal-900 text-white py-16 md:py-24 overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '50px 50px'
        }}></div>

        {/* Gradient Orbs */}
        <div className="absolute top-0 right-1/4 w-64 md:w-96 h-64 md:h-96 bg-teal-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-1/4 w-64 md:w-96 h-64 md:h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-2xl mb-6 md:mb-8">
              <i className="ri-shield-check-line text-3xl md:text-4xl text-white"></i>
            </div>
            <h1 className="text-3xl md:text-5xl font-black mb-4 md:mb-6">
              プライバシーポリシー
            </h1>
            <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto px-4">
              株式会社G11（以下「当社」）は、お客様の個人情報保護の重要性について認識し、<br className="hidden md:block" />
              個人情報の保護に関する法律を遵守すると共に、以下のプライバシーポリシーに従い、<br className="hidden md:block" />
              適切な取扱い及び保護に努めます。
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="bg-white rounded-xl md:rounded-2xl shadow-sm p-6 md:p-10 space-y-8 md:space-y-12">
          
          {/* Section 1 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第1条（個人情報）
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed">
              「個人情報」とは、個人情報保護法にいう「個人情報」を指すものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）を指します。
            </p>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第2条（個人情報の収集方法）
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
              当社は、お客様が利用登録をする際に氏名、生年月日、住所、電話番号、メールアドレス、銀行口座番号、クレジットカード番号、運転免許証番号などの個人情報をお尋ねすることがあります。また、お客様と提携先などとの間でなされたお客様の個人情報を含む取引記録や決済に関する情報を、当社の提携先（情報提供元、広告主、広告配信先などを含みます。以下、「提携先」といいます。）などから収集することがあります。
            </p>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第3条（個人情報を収集・利用する目的）
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4">
              当社が個人情報を収集・利用する目的は、以下のとおりです。
            </p>
            <ul className="space-y-3">
              {[
                '当社サービスの提供・運営のため',
                'お客様からのお問い合わせに回答するため（本人確認を行うことを含む）',
                'お客様が利用中のサービスの新機能、更新情報、キャンペーン等及び当社が提供する他のサービスの案内のメールを送付するため',
                'メンテナンス、重要なお知らせなど必要に応じたご連絡のため',
                '利用規約に違反したお客様や、不正・不当な目的でサービスを利用しようとするお客様の特定をし、ご利用をお断りするため',
                'お客様にご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため',
                '有料サービスにおいて、お客様に利用料金を請求するため',
                '上記の利用目的に付随する目的'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-sm md:text-base text-gray-700">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 md:mt-1 flex-shrink-0"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第4条（利用目的の変更）
            </h2>
            <ul className="space-y-3">
              {[
                '当社は、利用目的が変更前と関連性を有すると合理的に認められる場合に限り、個人情報の利用目的を変更するものとします。',
                '利用目的の変更を行った場合には、変更後の目的について、当社所定の方法により、お客様に通知し、または本ウェブサイト上に公表するものとします。'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-sm md:text-base text-gray-700">
                  <span className="flex-shrink-0 w-6 h-6 md:w-7 md:h-7 bg-teal-100 rounded-full flex items-center justify-center text-xs md:text-sm font-bold text-teal-700">
                    {index + 1}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第5条（個人情報の第三者提供）
            </h2>
            <ul className="space-y-4 md:space-y-6">
              <li className="text-sm md:text-base text-gray-700">
                <span className="font-bold text-gray-900">1.</span> 当社は、次に掲げる場合を除いて、あらかじめお客様の同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
                <ul className="mt-3 space-y-2 ml-4 md:ml-6">
                  {[
                    '人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき',
                    '公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき',
                    '国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき',
                    '予め次の事項を告知あるいは公表し、かつ当社が個人情報保護委員会に届出をしたとき'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm md:text-base">
                      <i className="ri-arrow-right-s-line text-teal-600 mt-0.5 md:mt-1 flex-shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </li>
              <li className="text-sm md:text-base text-gray-700">
                <span className="font-bold text-gray-900">2.</span> 前項の定めにかかわらず、次に掲げる場合には、当該情報の提供先は第三者に該当しないものとします。
                <ul className="mt-3 space-y-2 ml-4 md:ml-6">
                  {[
                    '当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合',
                    '合併その他の事由による事業の承継に伴って個人情報が提供される場合',
                    '個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について、あらかじめ本人に通知し、または本人が容易に知り得る状態に置いた場合'
                  ].map((item, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm md:text-base">
                      <i className="ri-arrow-right-s-line text-teal-600 mt-0.5 md:mt-1 flex-shrink-0"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第6条（個人情報の開示）
            </h2>
            <ul className="space-y-3">
              {[
                '当社は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示します。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。',
                '本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合',
                '当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合',
                'その他法令に違反することとなる場合',
                '前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則として開示いたしません。'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-sm md:text-base text-gray-700">
                  <i className="ri-checkbox-circle-fill text-teal-600 mt-0.5 md:mt-1 flex-shrink-0"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第7条（個人情報の訂正および削除）
            </h2>
            <ul className="space-y-3">
              {[
                'お客様は、当社の保有する自己の個人情報が誤った情報である場合には、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。',
                '当社は、お客様から前項の請求を受けてその請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。',
                '当社は、前項の規定に基づき訂正等を行った場合、または訂正等を行わない旨の決定をしたときは遅滞なく、これをお客様に通知します。'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-sm md:text-base text-gray-700">
                  <span className="flex-shrink-0 w-6 h-6 md:w-7 md:h-7 bg-teal-100 rounded-full flex items-center justify-center text-xs md:text-sm font-bold text-teal-700">
                    {index + 1}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第8条（個人情報の利用停止等）
            </h2>
            <ul className="space-y-3">
              {[
                '当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由により、その利用の停止または消去（以下、「利用停止等」といいます。）を求められた場合には、遅滞なく必要な調査を行います。',
                '前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行います。',
                '当社は、前項の規定に基づき利用停止等を行った場合、または利用停止等を行わない旨の決定をしたときは、遅滞なく、これをお客様に通知します。',
                '前2項にかかわらず、利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、お客様の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じるものとします。'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-sm md:text-base text-gray-700">
                  <span className="flex-shrink-0 w-6 h-6 md:w-7 md:h-7 bg-teal-100 rounded-full flex items-center justify-center text-xs md:text-sm font-bold text-teal-700">
                    {index + 1}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第9条（プライバシーポリシーの変更）
            </h2>
            <ul className="space-y-3">
              {[
                '本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、お客様に通知することなく、変更することができるものとします。',
                '当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとします。'
              ].map((item, index) => (
                <li key={index} className="flex items-start gap-3 text-sm md:text-base text-gray-700">
                  <span className="flex-shrink-0 w-6 h-6 md:w-7 md:h-7 bg-teal-100 rounded-full flex items-center justify-center text-xs md:text-sm font-bold text-teal-700">
                    {index + 1}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-xl md:text-2xl font-black text-gray-900 mb-4 md:mb-6 flex items-center gap-3">
              <div className="w-1 h-6 md:h-8 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full"></div>
              第10条（お問い合わせ窓口）
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-6">
              本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
            </p>
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-xl p-6 md:p-8 border border-teal-100">
              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-line text-xl md:text-2xl text-white"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm text-gray-600 mb-1">会社名</p>
                    <p className="text-base md:text-lg font-bold text-gray-900">株式会社G11</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl md:text-2xl text-white"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm text-gray-600 mb-1">所在地</p>
                    <p className="text-base md:text-lg font-bold text-gray-900">宮城県仙台市青葉区二日町12-25-2F</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-teal-500 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl md:text-2xl text-white"></i>
                  </div>
                  <div>
                    <p className="text-xs md:text-sm text-gray-600 mb-1">メールアドレス</p>
                    <p className="text-base md:text-lg font-bold text-gray-900">info@nextage.jp</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Last Updated */}
          <div className="pt-8 md:pt-12 border-t border-gray-200 text-center">
            <p className="text-xs md:text-sm text-gray-500">制定日：2025年1月1日</p>
            <p className="text-xs md:text-sm text-gray-500 mt-2">株式会社G11</p>
          </div>

        </div>

        {/* CTA Section */}
        <div className="mt-12 md:mt-16 bg-gradient-to-br from-teal-600 to-teal-800 rounded-xl md:rounded-2xl p-6 md:p-10 text-white text-center">
          <h3 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">ご不明な点がございますか？</h3>
          <p className="text-sm md:text-base text-teal-100 mb-6 md:mb-8 px-4">
            プライバシーポリシーに関するご質問やご相談は、お気軽にお問い合わせください。
          </p>
          <a 
            href="/contact" 
            className="inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-white text-teal-700 rounded-lg md:rounded-xl font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer text-sm md:text-base"
          >
            <i className="ri-mail-line text-lg md:text-xl"></i>
            <span>お問い合わせ</span>
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
}
